import React from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FiLock } from "react-icons/fi";

const EditContactInformation = ({ Show, Hide, Title }) => {
  return (
    <>
      <Modal show={Show} onHide={Hide}>
        <Modal.Header closeButton>
          <Modal.Title
            className="fw-bold hstack gap-2"
            style={{ fontSize: 15 }}
          >
            <span>{Title}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-2 section-title d-block">
            <Form.Label className="mb-1 fw-bold hstack gap-2">
              <FiLock /> Email Address
            </Form.Label>
            <Form.Control
              style={{ fontSize: 12 }}
              type="email"
              placeholder="abc@example.com"
            />
          </Form.Group>
          <Form.Group className="mb-2 section-title d-block">
            <Form.Label className="mb-1 fw-bold">Phone Number</Form.Label>
            <Form.Control
              style={{ fontSize: 12 }}
              type="tel"
              placeholder="+1 23456789"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="text-end">
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="outline-primary"
            onClick={Hide}
          >
            Cancel
          </Button>
          <Button
            className="py-1 px-3 rounded-1"
            style={{ fontSize: 13 }}
            variant="primary"
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditContactInformation;
